import { useState, useEffect } from 'react';
import { Header } from './Header';
import { Button } from 'semantic-ui-react';
import { cls }  from "../../../NUI/utils";
import { Divider } from '../Divider';
import ConsultWaitTimeIndicator from '@iscr/components/ConsultWaitTimeIndicator';
import { Link } from 'react-router';
import Welcome from './Welcome';
import NotificationsCountBannerApp from '../../../../notifications/view/app/NotificationsCountBannerApp';
import UserPic from '../../../../xAppLib/Users/UserPic';
import { ActiveConsult } from './ActiveConsult';
import { getUserDisplayName } from 'helpers/getUserDisplayName';
import AccountOnboarding from '@iscr/xAppLib/UIelems/AccountOnboarding';
import { useProfile, useExperiment } from '@iscr/xAppLib/Hooks';
import { WAIT_TIME_EXP } from "@iscr/views/pages/homepage/consts";

export function HeaderHome({user=false}) {
    const img_path = "/images/v2/home"
    const user_in = user?.user_in
    const [prof] = useProfile()
    const newUser = !prof?.hist.length;
    const isStaff = app.acl.is_work;
    // Staff aren't in the experiment, so don't count them as exposed
    const waitTimeExp = useExperiment(WAIT_TIME_EXP, { quiet: isStaff });
    const showWaitTimeIndicator = isStaff || waitTimeExp?.n === "show_wt"
    const showFootnote = !isStaff && app.settings?.avg_wait_med;

    const [scrollY, setScrollY] = useState(0);

    useEffect(() => {
        const handleScroll = () => {setScrollY(window.scrollY)};
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    });
    const browse_btn = <Button onClick={() => app.trigger(app.events.SIDEMENU, {view:'Conditions'})} secondary className="rounded blue large">Browse by medical condition</Button>

    const hearts = <>
                        <div className="flex justify-between align-center w-full absolute -bottom-2 left-0 right-0 mx-auto max-w-[300px]">
                            <img style={{ transform: `translateY(${scrollY * -0.1}px)` }} className="w-[80px] sm:w-[108px] -ml-6 object-cover object-top xl:hidden" src={`${img_path}/hearts-grouped-small.png`} alt="" />
                            <img style={{ transform: `translateY(${scrollY * -0.14}px)` }} className="w-[196px] h-auto absolute left-0 right-0 mx-auto -bottom-[60px] rotate-[3.043deg] xl:hidden z-10" src={`${img_path}/heart-single-large.png`} alt="" />
                            <img style={{ transform: `translateY(${scrollY * -0.1}px)` }} className="w-[80px] sm:w-[108px] -mr-9 object-cover object-top xl:hidden" src={`${img_path}/hearts-grouped2.png`} alt=""/>
                        </div>

                        <img style={{ transform: `translateY(${scrollY * -0.1}px)` }} className="shrink-0 w-auto h-[720px] absolute right-[calc(50%+370px)] bottom-0 hidden xl:block" src={`${img_path}/hearts-large-grouped.png`} alt="" />
                        <img style={{ transform: `translateY(${scrollY * -0.2}px)` }} className="absolute right-[calc(50%+410px)] bottom-[60px] hidden xl:block" src={`${img_path}/hearts-3.png`} alt="" />
                        <img style={{ transform: `translateY(${scrollY * -0.3}px)` }} className="absolute w-[140px] right-[calc(50%+370px)] bottom-[130px] hidden xl:block" src={`${img_path}/med-heart-1.png`} alt="" />
                    </>

    return (
        <Header
            sub_title={!user_in && "Doctors here for you 24/7"}
            title={!user_in && <>Australia's largest <br className="hidden lg:block"/>online medical clinic</>}
            nav={user_in}
            user={user_in}
            sidebar={!!user_in}
            current={'Home'}
            wrapper={cls("h-full !bg-is2-blue", !user_in && "xl:h-[660px] ")}
            clsn="home text-center"
            padding={cls(user_in ? "xl:max-w-[533px] w-full px-6 py-9 lg:pb-6 lg:pt-11 mx-auto" : "pt-11 px-6 pb-10 md:pt-[100px] xl:pt-[180px] mx-auto xl:ml-[50vw] lg:max-w-[600px]")}
        >
            <>
                <ActiveConsult limit={1} clsn="order-1 lg:hidden -mt-9 !-mx-6 mb-9"/>

                {user_in && <div className="order-2 lg:order-none flex flex-col justify-center items-center lg:items-start">
                                <UserPic
                                    photoURL={user?.user_det?.photoURL}
                                    email={user?.user_det?.email}
                                    name={getUserDisplayName(user, {
                                        format: 'full',
                                        defaultValue: 'User'
                                    })}
                                    size={72}
                                    className="!rounded-full !bg-cover !bg-no-repeat mb-6 lg:mb-3"
                                />
                                <Welcome clsn="lg:hidden mb-4"/>

                                {user_in &&<p className="hidden lg:block text-white font-medium">
                                    {getUserDisplayName(user, {
                                        format: 'full',
                                        defaultValue: 'User'
                                    })}
                                </p>}
                                {app.site_status?.notifications?.enable_indicator?.includes?.(app.runtime?.app) && (
                                    <>
                                        <div className="lg:hidden">
                                            <NotificationsCountBannerApp />
                                        </div>
                                    </>
                                )}
                            </div>}
                {newUser &&
                    <div className="block md:hidden order-2">
                        <AccountOnboarding />
                    </div>
                }

                {showWaitTimeIndicator && <div className="mb-7 mt-8 lg:hidden order-3">{isStaff ? <ConsultWaitTimeIndicator basic badge color="bg-is2-green" /> : <ConsultWaitTimeIndicator badge />}</div>}
                
                <div className={cls("w-full flex flex-col items-center mx-auto", user_in ? `lg:gap-3 lg:mt-12 lg:hidden order-4 ${!showWaitTimeIndicator && "!mt-[44px] lg:!mt-12"}` : "mb-[124px] md:w-[327px] lg:mt-[36px] xxl:mt-[60px] xl:ml-0 xl:hidden")}>
                    <Button data-testid="button-services" className={cls("!py-2.5 rounded !text-is2_lg !font-medium white !w-full sm:!w-[327px] !border-0")} onClick={() => app.trigger(app.events.SIDEMENU, {view:'Services'})} size="large">Select service</Button>
                    <p className={cls(user_in && "xl:hidden", "my-2")}>or</p>
                    {user_in ?  <Button secondary color="blue" className="w-full sm:w-fit" as={Link}>
                                    <span className="font-normal text-[#CCE0FC]" onClick={() => app.trigger(app.events.SIDEMENU, {view:'Conditions'})} >Browse by <span className="font-bold text-white">medical conditions</span></span>
                                </Button> : browse_btn}
                </div>

                {(showWaitTimeIndicator && showFootnote) && <span className="text-is2-blue-100 text-sm order-last mt-4 text-left lg:hidden">*Wait times may vary</span>}

                {!user_in && 
                    <div className="hidden xl:flex gap-4">
                        <Button onClick={() => app.trigger(app.events.SIDEMENU, {view:'Services'})} className="rounded white large !border-0">I'm new</Button>
                        {browse_btn}
                    </div>
                }

                {!user_in && hearts}

            </>
        </Header>
    );
}
